import { useRouter } from 'next/navigation';

import { Button } from '@/shared/ui/form/button';
import { BodyTextBoldSecondary } from '@/shared/ui/typography';
import { useI18n } from '@locales/client';
import styled from 'styled-components';

export default function AuthButtons() {
  const router = useRouter();
  const t = useI18n();

  return (
    <>
      <ButtonWrapper>
        <Button
          variant="orangeGradient"
          onClick={() => {
            router.push('/?modal=registration');
          }}
        >
          <BodyTextBoldSecondary>{t('auth.sign_up')}</BodyTextBoldSecondary>
        </Button>
        <Button
          variant="gray"
          onClick={() => {
            router.push('/?modal=auth');
          }}
        >
          <BodyTextBoldSecondary style={{ padding: '0 8px' }}>
            {t('auth.sign_in')}
          </BodyTextBoldSecondary>
        </Button>
      </ButtonWrapper>
    </>
  );
}

export const ButtonWrapper = styled.div`
  display: flex;
  gap: 8px;
  //margin: 0 18px;
  margin-top: 24px;
  margin-bottom: 20px;
  display: none;

  @media (max-width: 768px) {
    display: flex;
    padding: 0 18px;
  }
`;
